import { API } from 'aws-amplify'
import { toast } from 'react-semantic-toasts'
import constants from '../../../../utils/constants'

// ============================================================
// Costanti
// ============================================================

export const LOADING_CR_TOGGLE             = 'LOADING_CR_TOGGLE'
export const CR_TOGGLE_SUCCESS             = 'CR_TOGGLE_SUCCESS'
export const CR_TOGGLE_ERROR               = 'CR_TOGGLE_ERROR'

export const LOADING_BULK_APPROVE_PREVIEW  = 'LOADING_BULK_APPROVE_PREVIEW'
export const GET_BULK_APPROVE_PREVIEW      = 'GET_BULK_APPROVE_PREVIEW'
export const GET_BULK_APPROVE_PREVIEW_ERROR = 'GET_BULK_APPROVE_PREVIEW_ERROR'

export const LOADING_BULK_APPROVE_EXECUTE  = 'LOADING_BULK_APPROVE_EXECUTE'
export const BULK_APPROVE_EXECUTE_SUCCESS  = 'BULK_APPROVE_EXECUTE_SUCCESS'
export const BULK_APPROVE_EXECUTE_ERROR    = 'BULK_APPROVE_EXECUTE_ERROR'

export const LOADING_REVENUE_RESET_PREVIEW  = 'LOADING_REVENUE_RESET_PREVIEW'
export const GET_REVENUE_RESET_PREVIEW      = 'GET_REVENUE_RESET_PREVIEW'
export const GET_REVENUE_RESET_PREVIEW_ERROR = 'GET_REVENUE_RESET_PREVIEW_ERROR'

export const LOADING_REVENUE_RESET_EXECUTE  = 'LOADING_REVENUE_RESET_EXECUTE'
export const REVENUE_RESET_EXECUTE_SUCCESS  = 'REVENUE_RESET_EXECUTE_SUCCESS'
export const REVENUE_RESET_EXECUTE_ERROR    = 'REVENUE_RESET_EXECUTE_ERROR'

export const LOADING_OPEN_CRS              = 'LOADING_OPEN_CRS'
export const GET_OPEN_CRS                  = 'GET_OPEN_CRS'
export const GET_OPEN_CRS_ERROR            = 'GET_OPEN_CRS_ERROR'

export const LOADING_CR_CLEAN              = 'LOADING_CR_CLEAN'
export const CR_CLEAN_SUCCESS              = 'CR_CLEAN_SUCCESS'
export const CR_CLEAN_ERROR                = 'CR_CLEAN_ERROR'

export const LOADING_SET_SUPERCUTOFF       = 'LOADING_SET_SUPERCUTOFF'
export const SET_SUPERCUTOFF_SUCCESS       = 'SET_SUPERCUTOFF_SUCCESS'
export const SET_SUPERCUTOFF_ERROR         = 'SET_SUPERCUTOFF_ERROR'

export const LOADING_PROGRESS              = 'LOADING_PROGRESS'
export const GET_PROGRESS                  = 'GET_PROGRESS'
export const GET_PROGRESS_ERROR            = 'GET_PROGRESS_ERROR'

export const LOADING_ERRORS                = 'LOADING_ERRORS'
export const GET_ERRORS                    = 'GET_ERRORS'
export const GET_ERRORS_ERROR              = 'GET_ERRORS_ERROR'

export const LOADING_RETRY_ERRORS          = 'LOADING_RETRY_ERRORS'
export const RETRY_ERRORS_SUCCESS          = 'RETRY_ERRORS_SUCCESS'
export const RETRY_ERRORS_ERROR            = 'RETRY_ERRORS_ERROR'

export const LOADING_CR_STATUS             = 'LOADING_CR_STATUS'
export const GET_CR_STATUS                 = 'GET_CR_STATUS'
export const GET_CR_STATUS_ERROR           = 'GET_CR_STATUS_ERROR'

export const LOADING_STATE                 = 'LOADING_SUPERCUTOFF_STATE'
export const GET_STATE                     = 'GET_SUPERCUTOFF_STATE'
export const GET_STATE_ERROR               = 'GET_SUPERCUTOFF_STATE_ERROR'

export const LOADING_COMPLETE_ERRORS       = 'LOADING_COMPLETE_ERRORS'
export const COMPLETE_ERRORS_SUCCESS       = 'COMPLETE_ERRORS_SUCCESS'
export const COMPLETE_ERRORS_ERROR         = 'COMPLETE_ERRORS_ERROR'

// ============================================================
// Action creators puri
// ============================================================

export const loadingCrToggle = () => ({ type: LOADING_CR_TOGGLE })
export const crToggleSuccess = (data) => ({ type: CR_TOGGLE_SUCCESS, data })
export const crToggleError = () => ({ type: CR_TOGGLE_ERROR })

export const loadingBulkApprovePreview = () => ({ type: LOADING_BULK_APPROVE_PREVIEW })
export const getBulkApprovePreview = (data) => ({ type: GET_BULK_APPROVE_PREVIEW, data })
export const getBulkApprovePreviewError = () => ({ type: GET_BULK_APPROVE_PREVIEW_ERROR })

export const loadingBulkApproveExecute = () => ({ type: LOADING_BULK_APPROVE_EXECUTE })
export const bulkApproveExecuteSuccess = (data) => ({ type: BULK_APPROVE_EXECUTE_SUCCESS, data })
export const bulkApproveExecuteError = () => ({ type: BULK_APPROVE_EXECUTE_ERROR })

export const loadingRevenueResetPreview = () => ({ type: LOADING_REVENUE_RESET_PREVIEW })
export const getRevenueResetPreview = (data) => ({ type: GET_REVENUE_RESET_PREVIEW, data })
export const getRevenueResetPreviewError = () => ({ type: GET_REVENUE_RESET_PREVIEW_ERROR })

export const loadingRevenueResetExecute = () => ({ type: LOADING_REVENUE_RESET_EXECUTE })
export const revenueResetExecuteSuccess = (data) => ({ type: REVENUE_RESET_EXECUTE_SUCCESS, data })
export const revenueResetExecuteError = () => ({ type: REVENUE_RESET_EXECUTE_ERROR })

export const loadingOpenCrs = () => ({ type: LOADING_OPEN_CRS })
export const getOpenCrs = (data) => ({ type: GET_OPEN_CRS, data })
export const getOpenCrsError = () => ({ type: GET_OPEN_CRS_ERROR })

export const loadingCrClean = () => ({ type: LOADING_CR_CLEAN })
export const crCleanSuccess = (data) => ({ type: CR_CLEAN_SUCCESS, data })
export const crCleanError = () => ({ type: CR_CLEAN_ERROR })

export const loadingSetSupercutoff = () => ({ type: LOADING_SET_SUPERCUTOFF })
export const setSupercutoffSuccess = (data) => ({ type: SET_SUPERCUTOFF_SUCCESS, data })
export const setSupercutoffError = () => ({ type: SET_SUPERCUTOFF_ERROR })

export const loadingProgress = () => ({ type: LOADING_PROGRESS })
export const getProgress = (data) => ({ type: GET_PROGRESS, data })
export const getProgressError = () => ({ type: GET_PROGRESS_ERROR })

export const loadingErrors = () => ({ type: LOADING_ERRORS })
export const getErrors = (data) => ({ type: GET_ERRORS, data })
export const getErrorsError = () => ({ type: GET_ERRORS_ERROR })

export const loadingRetryErrors = () => ({ type: LOADING_RETRY_ERRORS })
export const retryErrorsSuccess = (data) => ({ type: RETRY_ERRORS_SUCCESS, data })
export const retryErrorsError = () => ({ type: RETRY_ERRORS_ERROR })

export const loadingCrStatus = () => ({ type: LOADING_CR_STATUS })
export const getCrStatus = (data) => ({ type: GET_CR_STATUS, data })
export const getCrStatusError = () => ({ type: GET_CR_STATUS_ERROR })

export const loadingState = () => ({ type: LOADING_STATE })
export const getState = (data) => ({ type: GET_STATE, data })
export const getStateError = () => ({ type: GET_STATE_ERROR })

export const loadingCompleteErrors = () => ({ type: LOADING_COMPLETE_ERRORS })
export const completeErrorsSuccess = (data) => ({ type: COMPLETE_ERRORS_SUCCESS, data })
export const completeErrorsError = () => ({ type: COMPLETE_ERRORS_ERROR })

// ============================================================
// Helper — rilevamento 409 STEP_ALREADY_COMPLETED
// ============================================================

/**
 * Detects HTTP 409 STEP_ALREADY_COMPLETED responses returned by execute endpoints
 * when the wizard step has already been marked completed server-side (idempotency).
 * In that case the FE refreshes the wizard state instead of surfacing an error toast.
 *
 * Body shape from BE: { error_code: "STEP_ALREADY_COMPLETED", error: "..." }
 *
 * @param {Object} error - Error thrown by AWS Amplify API call
 * @returns {boolean}
 */
const isStepAlreadyCompleted = (error) => {
  return Boolean(
    error
      && error.response
      && error.response.status === 409
      && error.response.data
      && error.response.data.error_code === 'STEP_ALREADY_COMPLETED'
  )
}

// ============================================================
// Thunk — Step 1 & 10: Blocco/Sblocco CR
// PUT /supercutoff/cr-toggle
// ============================================================

/**
 * Abilita o disabilita la creazione di CR tramite SSM.
 * @param {boolean} enabled - true per sbloccare, false per bloccare
 * @param {Function} onSuccess - Callback chiamata dopo il successo. Firma: fn(data)
 */
export const startCrToggle = (enabled, onSuccess) => async (dispatch) => {
  dispatch(loadingCrToggle())
  try {
    const data = await API.put('supercutoff', '/cr-toggle', {
      body: { enabled },
    })
    dispatch(crToggleSuccess(data))
    toast({
      title: 'SuperCutoff',
      description: enabled ? 'CR creation re-enabled successfully.' : 'CR creation blocked successfully.',
      icon: 'check',
      type: 'success',
      time: constants.TOAST_SUCCESS_TIMEOUT,
      animation: 'fly left',
    })
    if (onSuccess) onSuccess(data)
  } catch (error) {
    if (isStepAlreadyCompleted(error)) {
      // Reset del loading: senza questo, il flag resta a true per il resto della
      // sessione e qualunque bottone con disabled={loadingCrToggle || ...} resta bloccato.
      dispatch(crToggleError())
      dispatch(startGetSupercutoffState())
      return
    }
    dispatch(crToggleError())
    toast({
      title: 'SuperCutoff',
      description: enabled ? 'Failed to unblock CR creation. Try again.' : 'Failed to block CR creation. Try again.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}

// ============================================================
// Thunk — Step 2: Preview approvazione massiva
// POST /supercutoff/bulk-approve/preview
// ============================================================

/**
 * Recupera il conteggio di ore e spese pending da approvare.
 * @param {{ date_start: string, date_end: string }} params
 */
export const startBulkApprovePreview = (params) => async (dispatch) => {
  dispatch(loadingBulkApprovePreview())
  try {
    const data = await API.post('supercutoff', '/bulk-approve/preview', {
      body: params,
    })
    dispatch(getBulkApprovePreview(data))
  } catch (error) {
    dispatch(getBulkApprovePreviewError())
    toast({
      title: 'SuperCutoff',
      description: 'Failed to load bulk approve preview.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}

// ============================================================
// Thunk — Step 3: Approvazione massiva ore/spese
// POST /supercutoff/bulk-approve/execute
// ============================================================

/**
 * Esegue l'approvazione massiva di ore e spese pending.
 * @param {{ date_start: string, date_end: string }} params
 * @param {Function} onSuccess - Callback chiamata dopo il successo. Firma: fn(data)
 */
export const startBulkApproveExecute = (params, onSuccess) => async (dispatch) => {
  dispatch(loadingBulkApproveExecute())
  try {
    const data = await API.post('supercutoff', '/bulk-approve/execute', {
      body: params,
    })
    dispatch(bulkApproveExecuteSuccess(data))
    toast({
      title: 'SuperCutoff',
      description: `${data.hours_approved} hours and ${data.expenses_approved} expenses approved.`,
      icon: 'check',
      type: 'success',
      time: constants.TOAST_SUCCESS_TIMEOUT,
      animation: 'fly left',
    })
    if (onSuccess) onSuccess(data)
  } catch (error) {
    if (isStepAlreadyCompleted(error)) {
      // Reset del loading: senza questo, il flag resta a true per il resto della
      // sessione e qualunque bottone con disabled={loadingExecute || ...} resta bloccato.
      dispatch(bulkApproveExecuteError())
      dispatch(startGetSupercutoffState())
      return
    }
    dispatch(bulkApproveExecuteError())
    toast({
      title: 'SuperCutoff',
      description: 'Bulk approval failed. Try again.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}

// ============================================================
// Thunk — Step 4: Preview azzeramento ricavi
// POST /supercutoff/revenue-reset/preview
// ============================================================

/**
 * Recupera il conteggio e il dettaglio dei budget con ricavi da azzerare.
 * @param {{ cutoff_month: number, cutoff_year: number }} params
 */
export const startRevenueResetPreview = (params) => async (dispatch) => {
  dispatch(loadingRevenueResetPreview())
  try {
    const data = await API.post('supercutoff', '/revenue-reset/preview', {
      body: params,
    })
    dispatch(getRevenueResetPreview(data))
  } catch (error) {
    dispatch(getRevenueResetPreviewError())
    toast({
      title: 'SuperCutoff',
      description: 'Failed to load revenue reset preview.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}

// ============================================================
// Thunk — Step 5: Azzeramento ricavi
// POST /supercutoff/revenue-reset/execute
// ============================================================

/**
 * Azzera i ricavi sui budget pending del mese di chiusura.
 * @param {{ cutoff_month: number, cutoff_year: number }} params
 * @param {Function} onSuccess - Callback chiamata dopo il successo. Firma: fn(data)
 */
export const startRevenueResetExecute = (params, onSuccess) => async (dispatch) => {
  dispatch(loadingRevenueResetExecute())
  try {
    const data = await API.post('supercutoff', '/revenue-reset/execute', {
      body: params,
    })
    dispatch(revenueResetExecuteSuccess(data))
    toast({
      title: 'SuperCutoff',
      description: `${data.budgets_reset} budgets reset successfully.`,
      icon: 'check',
      type: 'success',
      time: constants.TOAST_SUCCESS_TIMEOUT,
      animation: 'fly left',
    })
    if (onSuccess) onSuccess(data)
  } catch (error) {
    if (isStepAlreadyCompleted(error)) {
      // Reset del loading: vedi nota in startCrToggle.
      dispatch(revenueResetExecuteError())
      dispatch(startGetSupercutoffState())
      return
    }
    dispatch(revenueResetExecuteError())
    toast({
      title: 'SuperCutoff',
      description: 'Revenue reset failed. Try again.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}

// ============================================================
// Thunk — Step 6a: Lista CR aperte
// GET /supercutoff/cr-open
// ============================================================

/**
 * Recupera la lista delle CR aperte (non completate) da mostrare a Controlling.
 * Il BE risponde con shape { cr_open: [...] }: estraiamo l'array prima di
 * salvarlo nello store, in modo che i consumer ricevano direttamente un array.
 * @param {Function} onSuccess - Callback chiamata dopo il successo. Firma: fn(data)
 */
export const startGetOpenCrs = (onSuccess) => async (dispatch) => {
  dispatch(loadingOpenCrs())
  try {
    const response = await API.get('supercutoff', '/cr-open', {})
    const data = response.cr_open
    dispatch(getOpenCrs(data))
    if (onSuccess) onSuccess(data)
  } catch (error) {
    dispatch(getOpenCrsError())
    toast({
      title: 'SuperCutoff',
      description: 'Failed to load open CRs.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}

// ============================================================
// Thunk — Step 6b: Pulizia CR
// POST /supercutoff/cr-clean
// ============================================================

/**
 * Elimina le CR selezionate e ripristina lo stato precedente dei PFE/budget.
 * @param {{ pfe_ids: number[] }} params
 * @param {Function} onSuccess - Callback chiamata dopo il successo. Firma: fn(data)
 */
export const startCrClean = (params, onSuccess) => async (dispatch) => {
  dispatch(loadingCrClean())
  try {
    const data = await API.post('supercutoff', '/cr-clean', {
      body: params,
    })
    dispatch(crCleanSuccess(data))
    toast({
      title: 'SuperCutoff',
      description: `${data.processed} CRs cleaned successfully.`,
      icon: 'check',
      type: 'success',
      time: constants.TOAST_SUCCESS_TIMEOUT,
      animation: 'fly left',
    })
    if (onSuccess) onSuccess(data)
  } catch (error) {
    if (isStepAlreadyCompleted(error)) {
      // Reset del loading: vedi nota in startCrToggle.
      dispatch(crCleanError())
      dispatch(startGetSupercutoffState())
      return
    }
    dispatch(crCleanError())
    toast({
      title: 'SuperCutoff',
      description: 'CR cleanup failed. Try again.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}

// ============================================================
// Thunk — Step 7: Settaggio SuperCutoff PM + trigger closure
// POST /supercutoff/set
// ============================================================

/**
 * Inserisce il record cutoff_pm con is_super_cutoff=1 e pubblica su SNS
 * per avviare la coda di closure.
 * @param {{ month: number, year: number }} params
 * @param {Function} onSuccess - Callback chiamata dopo il successo. Firma: fn(data)
 */
export const startSetSupercutoff = (params, onSuccess) => async (dispatch) => {
  dispatch(loadingSetSupercutoff())
  try {
    const data = await API.post('supercutoff', '/set', {
      body: params,
    })
    dispatch(setSupercutoffSuccess(data))
    toast({
      title: 'SuperCutoff',
      description: 'SuperCutoff set. Closure queue triggered.',
      icon: 'check',
      type: 'success',
      time: constants.TOAST_SUCCESS_TIMEOUT,
      animation: 'fly left',
    })
    if (onSuccess) onSuccess(data)
  } catch (error) {
    if (isStepAlreadyCompleted(error)) {
      // Reset del loading: vedi nota in startCrToggle.
      dispatch(setSupercutoffError())
      dispatch(startGetSupercutoffState())
      return
    }
    dispatch(setSupercutoffError())
    toast({
      title: 'SuperCutoff',
      description: 'Failed to set SuperCutoff. Try again.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}

// ============================================================
// Thunk — Step 8: Monitoraggio progresso coda
// GET /supercutoff/progress
// ============================================================

/**
 * Legge il progresso della coda di closure (polling manuale).
 * @param {Function} onSuccess - Callback chiamata dopo il successo. Firma: fn(data)
 */
export const startGetProgress = (onSuccess) => async (dispatch) => {
  dispatch(loadingProgress())
  try {
    const data = await API.get('supercutoff', '/progress', {})
    dispatch(getProgress(data))
    if (onSuccess) onSuccess(data)
  } catch (error) {
    dispatch(getProgressError())
    toast({
      title: 'SuperCutoff',
      description: 'Failed to refresh progress.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}

// ============================================================
// Thunk — Step 9a: Lettura errori
// GET /supercutoff/errors
// ============================================================

/**
 * Recupera la lista degli errori di closure dalla tabella supercutoff_error.
 */
export const startGetErrors = () => async (dispatch) => {
  dispatch(loadingErrors())
  try {
    const data = await API.get('supercutoff', '/errors', {})
    dispatch(getErrors(data))
  } catch (error) {
    dispatch(getErrorsError())
    toast({
      title: 'SuperCutoff',
      description: 'Failed to load errors.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}

// ============================================================
// Thunk — Step 9b: Retry errori
// POST /supercutoff/errors/retry
// ============================================================

/**
 * Reinvia i messaggi degli errori selezionati sulla coda SQS.
 * @param {{ error_ids: number[] }} params
 * @param {Function} onSuccess - Callback chiamata dopo il successo. Firma: fn(data)
 */
export const startRetryErrors = (params, onSuccess) => async (dispatch) => {
  dispatch(loadingRetryErrors())
  try {
    const data = await API.post('supercutoff', '/errors/retry', {
      body: params,
    })
    dispatch(retryErrorsSuccess(data))
    toast({
      title: 'SuperCutoff',
      description: `${data.retried} error(s) re-queued successfully.`,
      icon: 'check',
      type: 'success',
      time: constants.TOAST_SUCCESS_TIMEOUT,
      animation: 'fly left',
    })
    if (onSuccess) onSuccess(data)
  } catch (error) {
    dispatch(retryErrorsError())
    toast({
      title: 'SuperCutoff',
      description: 'Retry failed. Try again.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}

// ============================================================
// Thunk — Step 1 & 10: Stato corrente creazione CR
// GET /supercutoff/cr-status
//
// @deprecated cr_available is now exposed via GET /supercutoff/state.
// This thunk is kept for backward compatibility but is no longer invoked
// by the SuperCutoff module. The endpoint will be removed in the next release.
// ============================================================

/**
 * Recupera lo stato corrente della creazione CR (abilitata/bloccata).
 * @deprecated Use startGetSupercutoffState instead. cr_available is part of /state payload.
 * @param {Function} onSuccess - Callback chiamata dopo il successo. Firma: fn(data)
 */
export const startGetCrStatus = (onSuccess) => async (dispatch) => {
  dispatch(loadingCrStatus())
  try {
    const data = await API.get('supercutoff', '/cr-status', {})
    dispatch(getCrStatus(data))
    if (onSuccess) onSuccess(data)
  } catch (error) {
    dispatch(getCrStatusError())
    toast({
      title: 'SuperCutoff',
      description: 'Failed to load CR status.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}

// ============================================================
// Thunk — Stato persistente del wizard (single source of truth lato BE)
// GET /supercutoff/state
// ============================================================

/**
 * Fetches the persistent wizard state from the backend.
 * The payload is used by useSupercutoffWizard to hydrate the local reducer
 * so the wizard can resume from the correct step after a reload or across operators.
 *
 * No toast is emitted on error: the UI surfaces the failure inline with a retry
 * button (see SuperCutoffContainer). Toasts here would be redundant and noisy.
 */
export const startGetSupercutoffState = () => async (dispatch) => {
  dispatch(loadingState())
  try {
    const data = await API.get('supercutoff', '/state', {})
    dispatch(getState(data))
  } catch (error) {
    dispatch(getStateError())
  }
}

// ============================================================
// Thunk — Step 9c: Completamento step errori
// POST /supercutoff/errors/complete
// ============================================================

/**
 * Marks the 'errors' wizard step as completed server-side and advances current_step
 * to 'cr_unblock'. Replaces the previous client-only transition.
 * @param {Function} onSuccess - Callback invoked after a successful completion. Firma: fn(data)
 */
export const startCompleteErrors = (onSuccess) => async (dispatch) => {
  dispatch(loadingCompleteErrors())
  try {
    const data = await API.post('supercutoff', '/errors/complete', {})
    dispatch(completeErrorsSuccess(data))
    toast({
      title: 'SuperCutoff',
      description: 'Errors step completed.',
      icon: 'check',
      type: 'success',
      time: constants.TOAST_SUCCESS_TIMEOUT,
      animation: 'fly left',
    })
    if (onSuccess) onSuccess(data)
  } catch (error) {
    if (isStepAlreadyCompleted(error)) {
      // Reset del loading: vedi nota in startCrToggle.
      dispatch(completeErrorsError())
      dispatch(startGetSupercutoffState())
      return
    }
    dispatch(completeErrorsError())
    toast({
      title: 'SuperCutoff',
      description: 'Failed to complete errors step. Try again.',
      type: 'error',
      icon: 'warning',
      time: constants.TOAST_ERROR_TIMEOUT,
      animation: 'fly left',
    })
  }
}
